import React from 'react';

type Props = {
    children?: React.ReactNode;
};

export default function AdminPageWrapper({ children }: Props) {
    return <div className="page-wrapper">{children}</div>;
}
